<div class="twc-container twc-m-2">
    <div class="twc-row twc-col-12 twc-mb-2">
        <h3 class="twc-h3">{{'UPLOAD.UAV_CONFIGURATION' | translate}}</h3>
    </div>

    <div>
        <label class="twc-form-label">
            <strong>{{'UPLOAD.POINTCLOUD_OPTIONS' | translate}}</strong>
        </label>

        <div class="twc-checkbox">
            <input class="twc-checkbox-input" type="checkbox" id="skip-metadata-images-checkbox"
                [(ngModel)]="options.skipImages">

            <label class="twc-checkbox-label" for="skip-metadata-images-checkbox">
                {{'UPLOAD.SKIP_NO_METADATA_IMAGES' | translate}}
            </label>
        </div>
    </div>
</div>